import { TTopCategory } from '../data';

export const findTopCategoryData = (
	categories: TTopCategory[],
	searchCategoryId: number
): TTopCategory => categories.filter(({ topCategoryId }) => topCategoryId === searchCategoryId)[0];
